export const MAX_MESSAGE_LENGTH = 160;

export const MESSAGE_PLACEHOLDER =
  'Puoi scrivere messaggi come "si raccomanda di eseguire il cambio dell\'olio ogni 20 gg."';

// `value` is the promemoriaStileVisivo the API stores, so it travels unchanged
// from the radio group to the DTO. `label` carries the Italian text on screen.
// The colors stay here rather than in the app theme: they are status colors a
// brand must never repaint, and this screen is the only thing that draws them.
export const REMINDER_STYLES = [
  {
    value: 'INFO',
    label: 'Info',
    description: 'Comunicazioni neutre',
    backgroundColor: '#E3F2FD',
    borderColor: '#1976D2',
    color: '#1976D2',
  },
  {
    value: 'WARN',
    label: 'Attenzione',
    description: 'Attenzione richiesta, non bloccante',
    backgroundColor: '#FFFDE7',
    borderColor: '#E0C240',
    color: '#8D6E00',
  },
  {
    value: 'CRITICAL',
    label: 'Critico',
    description: 'Rischio compliance o scadenze',
    backgroundColor: '#FFEBEE',
    borderColor: '#D72A2A',
    color: '#D72A2A',
  },
];

export const REMOVE_CONFIRM_DIALOG = {
  title: 'Sei sicuro di voler rimuovere il promemoria?',
  description:
    "Se lo fai, non visualizzerai più il promemoria all'interno del controllo.",
  cancelButtonLabel: 'Annulla',
  confirmButtonLabel: 'Rimuovi promemoria',
};
